import React, { useEffect, useState } from "react";
import ModeListing from "./ModeListing";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/ModeSlice";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { MdDeleteOutline } from "react-icons/md";
import { RxPencil1 } from "react-icons/rx";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import AddModeFormWrapper from "../Add/AddModeFormWrapper";
import {
  useGetModePaginationQuery,
  useDeleteModeMutation,
} from "src/services/ModeServices";
import { showToast } from "src/utils/showToaster";
import EditModeFormWrapper from "../Edit/EditModeFormWrapper";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from "src/helpers/userAccessFun";

type Props = {};

const ModeListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const [isOpenAddFrom, setIsOpenAddForm] = useState(false);
  const [isOpenEditFrom, setIsOpenEditForm] = useState(false);
  const [modeId, setModeId] = useState("");

  const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading } =
    useSelector((state: RootState) => state.mode);
  //API
  const [deleteMode] = useDeleteModeMutation();

  const { data, isLoading, isFetching } = useGetModePaginationQuery({
    limit:rowsPerPage,
    searchValue: searchValue,
    params: ["modeName", "modeDescription", "isVirtual"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
      dispatch(setIsTableLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);

    const getActionOptions = (row: any) => {
      return [
        {
          label: (
            <div className="flex gap-2 items-center text-secondary-main">
              <RxPencil1 className="text-lg" /> Edit
            </div>
          ),
          onClick: () => {
            setModeId(row._id);
            setIsOpenEditForm(true);
          },
          actionName: UserModuleActionTypes.EDIT,
        moduleName: UserModuleNameTypes.MODES
        },
        {
          label: (
            <div className="flex gap-2 items-center text-red-600 font-semibold">
              <MdDeleteOutline className="text-lg" /> Delete
            </div>
          ),
          onClick: () => {
            showConfirmationDialog({
              title: "Heads Up",
              text: "Are you sure want to Delete this Mode ?",
              icon: "question",
              showCancelButton: true,
              next: (result) => {
                if (result.isConfirmed) {
                  deleteMode(row?._id).then((res: any) => {
                    if (res?.error) {
                      showToast("error", res?.error?.data?.message);
                    } else {
                      if (res?.data?.status) {
                        showToast("success", res?.data?.message);
                      } else {
                        showToast("error", res?.data?.message);
                      }
                    }
                  });
                }
              },
            });
          },
          actionName: UserModuleActionTypes.DELETE,
          moduleName: UserModuleNameTypes.MODES
        },
      ];
    };

  const columns: columnTypes[] = [
    {
      field: "modeName",
      headerName: "Mode Name",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row.modeName} </span>,
    },
    {
      field: "modeDescription",
      headerName: "Mode Description",
      extraClasses : 'py-2',
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row?.modeDescription} </span>,
    },
    {
      field: "isVirtual",
      headerName: "Is Virtual",
      flex: "flex-[1.5_1.5_0%]",
      renderCell: (row: any) => <span> {row?.isVirtual ? 'YES' : 'NO'} </span>,
    },

    {
      noAuthRequired: true,
      field: "action",
      headerName: "Action",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => {
        const options = getActionOptions(row);
        return <ATMMenu options={options} orientation="vertical" />;
      },
    },
  ];

  return (
    <div>
      <ModeListing
        columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.MODES,
          actionName: UserModuleActionTypes.LIST,
          columns: columns
        })}
        rows={items}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
        onAddNew={() => setIsOpenAddForm(true)}
      />
      {isOpenAddFrom ? (
        <AddModeFormWrapper onClose={() => setIsOpenAddForm(false)} />
      ) : null}
      {isOpenEditFrom ? (
        <EditModeFormWrapper
          modeId={modeId}
          onClose={() => setIsOpenEditForm(false)}
        />
      ) : null}
    </div>
  );
};

export default ModeListingWrapper;
